import { Token } from '@/domain/types/Token'
import { Address } from 'viem'

export interface Permit2Data {
  token: Token
  spender: Address // vault
  amount: bigint
  expiration: number
  nonce: number
  sigDeadline: bigint
  signature: `0x${string}`
}

export interface Permit2Store {
  add: (permit: Permit2Data) => void
  find: (token: Token, spender: Address) => Permit2Data | undefined
}

export function createPermit2Store(): Permit2Store {
  const permits: Permit2Data[] = []

   
  const add = (permit: Permit2Data): void => {
    // Remove any existing permit for the same token+spender
    const existingIndex = permits.findIndex(
      (p) => p.token.address === permit.token.address && p.spender === permit.spender,
    )
    if (existingIndex >= 0) {
      permits.splice(existingIndex, 1)
    }
    permits.push(permit)
  }

  const find = (token: Token, spender: Address): Permit2Data | undefined => {
    return permits.find((p) => p.token.address === token.address && p.spender === spender)
  }
   

  return {
    add,
    find,
  }
}

